import TenantLevelEnum from './TenantLevelEnum';

/**
 * Extracts tenant query parameters (`t0`, `t1`, `t2`, …) present in the given
 * URLSearchParams, based on the levels defined in TenantLevelEnum.
 */
export default function extractTenantQueryParams(
  searchParams: URLSearchParams
): Record<string, string> {
  const result: Record<string, string> = {};

  Object.values(TenantLevelEnum)
    .filter((level): level is number => typeof level === 'number')
    .forEach((level) => {
      const paramKey = `t${level}`;
      const value = searchParams.get(paramKey);
      if (value) {
        result[paramKey] = value;
      }
    });

  return result;
}
